module.exports = __webpack_public_path__ + "videos/trakken_website_header_video.a23cb80.mp4";